import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";

export default function EditNotesDialog({open, onClose, notes, onNotesChange, onSave, loading}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>Modifier les notes</DialogTitle>
            <DialogContent>
                <TextField
                    minRows={3}
                    value={notes || ""}
                    onChange={(e) => onNotesChange(e.target.value)}
                    style={{width: "100%", maxWidth: "100%", marginTop: 4}}
                    placeholder="Ajouter des notes concernant cette réservation..."
                    multiline
                    disabled={loading}
                    autoFocus
                    label="Notes"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button variant="contained" onClick={onSave} disabled={loading}>Enregistrer</Button>
            </DialogActions>
        </Dialog>
    );
}
